import * as React from "react";

import { GFInitialState, GFPlan, GFUser } from "../../models/models";
import { Stripe, StripeElements } from "@stripe/stripe-js";
import {
  couponCheck,
  directPaymentSignup,
  updateSubscription,
} from "../../actions/paymentActions";
import {
  manualAjaxEnd,
  manualAjaxStart,
} from "../../actions/ajaxStatusActions";

import { Modal } from "react-bootstrap";
import DirectPaymentSection from "./DirectPaymentSection";
import { connect } from "react-redux";
import constants from "../../constants";
import { toastr } from "react-redux-toastr";
import utils from '../payment/utils';

interface Props {
  selectedPlan: GFPlan;
  stripe: Stripe;
  show: boolean;
  hide: () => void;
  togglePlanRecurringType: () => void;
  elements: StripeElements;
  manualAjaxStart: typeof manualAjaxStart;
  manualAjaxEnd: typeof manualAjaxEnd;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  utm_term: string;
  gclid: string;
}
interface DispatchProps {
  user: GFUser;
  couponCheck: (couponCode: string) => Promise<void>;
  loading: boolean;
  directPaymentSignup: (
    paymentPlan: string,
    quantity: number,
    paymentToken: any,
    stripeCoupon: string,
    user: any,
  ) => Promise<any>;
  updateSubscription: (paymentPlan: string, quantity: number) => Promise<void>;
}

interface State {
  stripeCouponDetails?: any;
  stripeCoupon: string;
}

class DirectCheckoutModalClass extends React.Component<Props & DispatchProps, State> {
  constructor(props: Props & DispatchProps) {
    super(props);
    this.state = {
      stripeCoupon: "",
    };
  }

  calculateAmount = (): string => {
    const displayAmount = utils.totalPrice(this.props.selectedPlan);

    return `Pay $${displayAmount}/${this.props.selectedPlan.time}`;
  };

  checkStripeCoupon = (e: any) => {
    e.preventDefault();
    this.props
      .couponCheck(this.state.stripeCoupon)
      .then((coupon) => {
        this.setState({ stripeCouponDetails: coupon });
      })
      .catch((error) => {
        console.error("Unable to apply coupon", error);
        let message = '';
        if (error.response && error.response.status === 404) {
          message = "We were not able to find a coupon with that code.";
        }
        if (message.length) {
          toastr.error("Error", message, constants.toastrError);
        } else {
          constants.handleError(error, 'apply coupon')
        }
      });
  };

  handleChange = (e: any) => {
    if (e) {
      e.preventDefault();
    }
    const targetName = e.currentTarget.name;
    this.setState({ [targetName]: e.currentTarget.value } as State);
  };

  render() {
    const displayAmount = this.calculateAmount();

    return (
      <Modal show={this.props.show} onHide={this.props.hide}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Manage Payment</Modal.Title>
        </Modal.Header>
        <DirectPaymentSection
          {...this.props}
          displayAmount={displayAmount}
          stripeCoupon={this.state.stripeCoupon}
          stripeCouponDetails={this.state.stripeCouponDetails}
          couponChange={this.handleChange}
          checkStripeCoupon={this.checkStripeCoupon}
          togglePlanRecurringType={this.props.togglePlanRecurringType}
        />
      </Modal>
    );
  }
}

const mapStateToProps = (state: GFInitialState, ownProps: any) => {
  return {
    loading: state.ajaxCallsInProgress > 0,
  };
};

const DirectCheckoutModal = connect(mapStateToProps, {
  couponCheck,
  updateSubscription,
  directPaymentSignup,
  manualAjaxEnd,
  manualAjaxStart,
})(DirectCheckoutModalClass);
export default DirectCheckoutModal;
